import React from 'react'
import styled from 'styled-components'
import { SpeedResultState } from 'src/Common/SpeedResultState'
import ExpectationBulletPoint from 'src/Result/ExpectationDetail/ExpectationBulletPoint'
import { localize } from 'src/lib/localize'

const Container = styled.div`
  flex: 1;
`

const title1 = localize('LABEL')(
  'Stream 4K video with smooth playback with slow buffer'
)
const title2 = localize('LABEL')('Fast web browsing')
const title3 = localize('LABEL')('Unreliable video calls')
const title4 = localize('LABEL')('Slow connected gaming')

const SlowExpectationDetails = () => {
  return (
    <Container>
      <ExpectationBulletPoint
        resultState={SpeedResultState.SLOW}
        title={title1}
      />
      <ExpectationBulletPoint
        resultState={SpeedResultState.SLOW}
        title={title2}
      />
      <ExpectationBulletPoint
        resultState={SpeedResultState.UNSTABLE}
        title={title3}
      />
      <ExpectationBulletPoint
        resultState={SpeedResultState.UNSTABLE}
        title={title4}
      />
    </Container>
  )
}

export default SlowExpectationDetails
